export abstract class MessagesEvent {}

export class MessagesLoad extends MessagesEvent {}
